import React, { useState } from 'react';
import { Icon } from 'components/ui';
import { routes } from 'constants/config';
import request from 'utils/request_ajax';
import { getStatusText } from '../../helpers';
import RSVPPopover from './RSVPPopover';

const RSVPStatus = ({
  attendee,
  event,
  showAttendanceDropdown,
  updateAttendance,
  isMultiSession,
  currentSessionId,
  rsvpType,
  sessions,
}) => {
  const session = attendee.sessions[0];
  const { createdFrom, rsvpStatus } = session;
  const [popoverOpen, setPopoverOpen] = useState(false);
  const currentSession = currentSessionId
    ? sessions.find(
        eventSession => Number(eventSession.id) === Number(currentSessionId),
      )
    : sessions[0];
  const attendanceTaken = currentSession.attendance_taken;

  const removeAttendance = () => {
    const url = routes.IN_PERSON_TRAINING.SESSION_ATTENDANCE(
      session.id,
      session.attendanceId,
    );
    request.delete(url).then(({ success }) => {
      if (success) updateAttendance();
    });
  };

  const changeAttendanceStatus = newStatus => {
    const url = routes.IN_PERSON_TRAINING.RSVP_ALL_GUESTS(event.id);
    request
      .putJSON(url, {
        userId: attendee.id,
        rsvpStatus: newStatus,
      })
      .then(({ data }) => {
        if (data?.sessions.length) {
          const updateSession = currentSessionId
            ? data.sessions.find(x => x.id === currentSessionId)
            : data.sessions[0];
          updateAttendance(updateSession);
          setPopoverOpen(false);
        }
      });
  };

  const changeAttendanceStatusSingle = newStatus => {
    const url = routes.IN_PERSON_TRAINING.RSVP_SINGLE_GUESTS(
      event.id,
      currentSessionId,
    );

    request
      .putJSON(url, {
        userId: attendee.id,
        rsvpStatus: newStatus,
      })
      .then(({ data }) => {
        if (data?.sessions.length) {
          updateAttendance(data.sessions.find(x => x.id === currentSessionId));
          setPopoverOpen(false);
        }
      });
  };

  if (createdFrom === 'created_manually' && event.last_session) {
    return null;
  }

  return (
    <>
      <div>{getStatusText(rsvpStatus, true)}</div>
      {showAttendanceDropdown && !attendanceTaken && !isMultiSession && (
        <div className="pos-r">
          <button
            type="button"
            onClick={() => setPopoverOpen(!popoverOpen)}
            className="u-resetBtn AttendanceRowActions"
          >
            <Icon name="chevron-down" />
          </button>
          {popoverOpen && (
            <RSVPPopover
              removeAttendance={removeAttendance}
              changeAttendanceStatus={changeAttendanceStatus}
              status={rsvpStatus}
              hide={() => setPopoverOpen(!popoverOpen)}
              isMultiSession={isMultiSession}
            />
          )}
        </div>
      )}
      {showAttendanceDropdown &&
        !attendanceTaken &&
        isMultiSession &&
        currentSessionId && (
          <div className="pos-r">
            <button
              type="button"
              onClick={() => setPopoverOpen(!popoverOpen)}
              className="u-resetBtn AttendanceRowActions mr-64"
            >
              <Icon name="chevron-down" />
            </button>
            {popoverOpen && (
              <RSVPPopover
                removeAttendance={removeAttendance}
                changeAttendanceStatus={
                  rsvpType === 'single'
                    ? changeAttendanceStatusSingle
                    : changeAttendanceStatus
                }
                status={rsvpStatus}
                isMultiSession={isMultiSession}
                hide={() => setPopoverOpen(!popoverOpen)}
              />
            )}
          </div>
        )}
    </>
  );
};

export default RSVPStatus;
